import $trace from '@beukay/trace';
import { Drawer } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Link } from 'umi';
import SearchBar from '@/components/SearchBar';
import LazyImage from '../LazyImage';
import styles from './index.less';

type SearchMenuProps = {
  visible: boolean;
  wordsList?: Array<string>;
  skuItemList: Array<API.SpuDetailVO>;
  onClose: (flag: boolean) => void;
  placement: 'top' | 'right' | 'bottom' | 'left';
};

const RECENT_SEARCH_KEY_NAME = 'recentSearchList';

const SearchMenu = ({
  visible = false,
  onClose,
  wordsList,
  skuItemList,
  placement = 'top',
}: SearchMenuProps) => {
  const [inputVal, setInputVal] = useState('');
  const [recentSearchList, setRecentSearchList] = useState(
    JSON.parse(localStorage.getItem(RECENT_SEARCH_KEY_NAME) || '[]'),
  );

  const handleTrace = (type: string, value: string) => {
    if (type === 'input') {
      $trace.track('search_btn_click', {
        keyword_type: '手动输入',
        search_keyword: value,
      });
    } else if (type === 'keyword') {
      $trace.track('search_btn_click', {
        keyword_type: '推荐词',
        search_keyword: value,
      });
    }
  };

  useEffect(() => {
    setInputVal('');
  }, [visible]);
  const listData =
    skuItemList && skuItemList.length > 3
      ? skuItemList.slice(0, 3)
      : skuItemList;

  // 记录最近搜索
  const recordRecentSearchList = (value: string) => {
    const list = JSON.parse(
      localStorage.getItem(RECENT_SEARCH_KEY_NAME) || '[]',
    )?.filter((item: string) => item !== value);
    list.unshift(value);
    if (list.length > 9) {
      list.pop();
    }
    setRecentSearchList(list);
    localStorage.setItem(RECENT_SEARCH_KEY_NAME, JSON.stringify(list));
  };

  // 清除搜索记录
  const clearSearchRecord = () => {
    localStorage.setItem(RECENT_SEARCH_KEY_NAME, JSON.stringify([]));
    setRecentSearchList([]);
  };

  return (
    <>
      <Drawer
        title="Basic Drawer"
        onClose={() => onClose(false)}
        placement={placement}
        height={'auto'}
        open={visible}
        key={placement}
        className={styles.searchMenuDrawer}
      >
        <SearchBar
          value={inputVal}
          visible={visible}
          activeId="all" // 默认下拉类型
          onClickClose={() => onClose(false)}
          setRecentSearchList={recordRecentSearchList}
          onClickSearch={(item: any) => handleTrace('input', item?.searchKey)} // 点击搜索按钮执行
        />
        <div className="bg-[#fff] pb-[64px]">
          <div className="flex w-[1226px] mx-auto pt-[32px] bg-[#fff] gap-x-[168px]">
            <div className="w-[364px]">
              {Boolean(recentSearchList?.length) && (
                <div className="flex items-center justify-start gap-x-[8px] mb-[16px]">
                  <span className="text-[16px] !text-[#141414] leading-[22px] font-[500]">
                    最近搜索
                  </span>
                  <span
                    onClick={clearSearchRecord}
                    className="text-[12px] text-[#999999] cursor-pointer hover:font-[500]"
                  >
                    清除搜索
                  </span>
                </div>
              )}
              {Boolean(recentSearchList?.length) && (
                <div className="flex flex-wrap gap-y-[12px] w-[364px] mb-[24px] gap-x-[16px]">
                  {recentSearchList?.map((item: string, index: number) => {
                    const isMultiplesOfThree = (index + 1) % 3 === 0;
                    const isSecondOfEachLine = index % 3 === 1;
                    return (
                      <div
                        key={index}
                        title={item}
                        className={classNames(
                          'text-[#666666] text-[14px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden truncate',
                          isMultiplesOfThree ? 'text-right' : '',
                          isSecondOfEachLine ? 'text-center' : '',
                          styles.recordItem,
                        )}
                        onClick={() => {
                          window.open(
                            `/category?keyword=${encodeURIComponent(item)}`,
                            '_blank',
                          );
                          recordRecentSearchList(item);
                        }}
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>
              )}

              {(listData.length > 0 || (wordsList && wordsList.length > 0)) && (
                <>
                  <div className="flex items-center justify-start gap-x-[8px] mb-[16px] text-[16px] !text-[#141414] font-[500]">
                    搜索热词
                  </div>
                  <div className="flex flex-wrap gap-y-[12px] w-[364px] mb-[24px] gap-x-[16px]">
                    {wordsList?.map((item, index) => {
                      const isMultiplesOfThree = (index + 1) % 3 === 0;
                      const isSecondOfEachLine = index % 3 === 1;
                      return (
                        <div
                          key={item}
                          onClick={() => {
                            setInputVal(item);
                            if (item) {
                              window.open(
                                `/category?keyword=${encodeURIComponent(item)}`,
                                '_blank',
                              );
                              recordRecentSearchList(item);
                              handleTrace('keyword', item);
                            }
                          }}
                          className={classNames(
                            'text-[#666666] text-[14px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden truncate',
                            isMultiplesOfThree ? 'text-right' : '',
                            isSecondOfEachLine ? 'text-center' : '',
                            styles.recordItem,
                          )}
                        >
                          <span>{item}</span>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
            <div>
              {listData.length > 0 && (
                <>
                  <div className="text-[16px] !text-[#141414] leading-[22px] mb-[16px] font-[500]">
                    优选原料
                  </div>
                  <div className="flex gap-x-[32px] flex-wrap w-[694px]">
                    {listData?.map((item) => {
                      return (
                        <Link
                          target="_blank"
                          rel="noreferrer"
                          key={item.spuCode}
                          to={`/product/${item?.spuCode} `}
                          className="cursor-pointer"
                        >
                          <div className="w-[210px] h-[210px] bg-[#F4F4F4]">
                            <LazyImage
                              src={item?.mainImg}
                              className="w-[210px] h-[210px] object-cover"
                            />
                          </div>
                          <div
                            className={classNames(
                              `text-[16px] text-[#333333] mt-[16px] font-normal w-[210px] text-left
                               limit-rows2 truncate overflow-hidden whitespace-normal leading-[30px]`,
                            )}
                            title={item?.title}
                          >
                            {item?.title}
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default SearchMenu;
